module.exports = __webpack_public_path__ + "static/media/mcsnetLogo.38e15cea.png";